/**
 * PDP brand/engagement: view ping + like button (shop3d.io API).
 */
(function () {
  var API_BASE = 'https://app.shop3d.io/api/shopify';

  function post(path, body) {
    return fetch(API_BASE + path, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function formatCount(n) {
    var value = Number(n) || 0;
    if (value < 1000) return String(value);
    if (value < 10000) return (Math.round(value / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'k';
    if (value < 1000000) return Math.round(value / 1000) + 'k';
    return (Math.round(value / 100000) / 10).toFixed(1).replace(/\.0$/, '') + 'm';
  }

  function likeLabel(count) {
    if (count === 1) return '1 like';
    if (count > 1) return formatCount(count) + ' likes';
    return 'Like';
  }

  function viewLabel(count) {
    if (count === 1) return '1 view';
    return formatCount(count) + ' views';
  }

  function bindMeta(root) {
    if (root.getAttribute('data-og-meta-bound')) return;
    root.setAttribute('data-og-meta-bound', 'true');

    var productId = Number(root.getAttribute('data-product-id'));
    var platformStoreConnect = root.getAttribute('data-platform-store-connect') || 'only-games';
    if (!productId) return;

    var payload = {
      productId: productId,
      platformStoreConnect: platformStoreConnect,
    };

    post('/view', payload).catch(function () {});

    var likeBtn = root.querySelector('[data-og-like]');
    var likeLabelEl = root.querySelector('[data-og-like-label]');
    var viewLabelEl = root.querySelector('[data-og-view-label]');

    var likeCount = Number(root.getAttribute('data-like-count')) || 0;
    var viewCount = Number(root.getAttribute('data-view-count')) || 0;

    if (viewLabelEl) {
      viewLabelEl.textContent = viewLabel(viewCount + 1);
      root.setAttribute('data-view-count', String(viewCount + 1));
    }

    if (!likeBtn) return;

    likeBtn.addEventListener('click', function () {
      if (likeBtn.disabled || likeBtn.getAttribute('data-liked') === 'true') return;
      likeBtn.disabled = true;

      var next = likeCount + 1;
      if (likeLabelEl) likeLabelEl.textContent = likeLabel(next);
      likeBtn.setAttribute('data-liked', 'true');
      likeBtn.classList.add('is-liked');

      post('/like', payload)
        .then(function (res) {
          if (!res.ok) throw new Error('like failed');
          likeCount = next;
          root.setAttribute('data-like-count', String(likeCount));
        })
        .catch(function () {
          likeCount = Number(root.getAttribute('data-like-count')) || likeCount;
          if (likeLabelEl) likeLabelEl.textContent = likeLabel(likeCount);
          likeBtn.removeAttribute('data-liked');
          likeBtn.classList.remove('is-liked');
          likeBtn.disabled = false;
        });
    });
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('[data-og-product-meta]').forEach(bindMeta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindAll();
    });
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
